export default __webpack_public_path__ + "static/media/calender7.4010ae05.svg";